const responseParams = {
  userPrincipalName: true,
  firstName: true,
  lastName: true,
  companyName: true,
  email: true,
  carrier: true,
  carrierId: true,
  tractorNumber: true,
  carrierTier: true,
  carrierScac: true,
  registered: true,
  image: true,
  address: {
    addressLine1: true,
    addressLine2: true,
    addressType: true,
    city: true,
    state: true,
    postalCode: true,
  },
  mobileNumber: true,
  userApplicationDetails: {
    roles: {
      roleId: true,
      roleName: true,
    },
    attributes: {
      requestedRoles:true,
    }
  },
  updatedTimeStamp: true,
};

const getMemberresponseParams = {
  upn: true,
  firstName: true,
  lastName: true,
  companyName: true,
  email: true,
  carrier: true,
  carrierId: true,
  tractorNumber: true,
  carrierTier: true,
  carrierScac: true,
  registered: true,
  image: true,
  address: {
    addressLine1: true,
    addressLine2: true,
    addressType: true,
    city: true,
    state: true,
    postalCode: true,
  },
  mobileNumber: true,
  userApplicationDetails: {
    roles: {
      roleId: true,
      roleName: true,
    },
    attributes: {
      requestedRoles:true,
    }
  },
  updatedTimeStamp: true,
  phoneNumberDetails :{
     number: true,
     phoneNumberType: true,
     },
  userLastLogin: true
};

const getMemberresponseParamsForWeb = {
  upn: true,
  firstName: true,
  lastName: true,
  companyName: true,
  email: true,
  carrier: true,
  carrierId: true,
  tractorNumber: true,
  carrierTier: true,
  carrierScac: true,
  registered: true,
  image: true,
  address: {
    addressLine1: true,
    addressLine2: true,
    addressType: true,
    city: true,
    state: true,
    postalCode: true,
  },
  mobileNumber: true,
  userApplicationDetails: {
    roles: {
      roleId: true,
      roleName: true,
    },
    attributes: {
      requestedRoles:true,
    }
  },
  updatedTimeStamp: true,
  phoneNumberDetails :{
     number: true,
     phoneNumberType: true,
     },
  userLastLogin: true,
  assignedLoadCount: true,
  canAssignLoad: true
};

const memberResponseParams = {
  userPrincipalName: true,
  firstName: true,
  lastName: true,
  companyName: true,
  email: true,
  carrier: true,
  carrierId: true,
  tractorNumber: true,
  carrierTier: true,
  carrierScac: true,
  registered: true,
  image: true,
  address: {
    addressLine1: true,
    addressLine2: true,
    addressType: true,
    city: true,
    state: true,
    postalCode: true,
  },
  mobileNumber: true,
  userApplicationDetails: {
    roles: {
      roleId: true,
      roleName: true,
    }
  },
  updatedTimeStamp: true,
};
const CarrierContactInfo = {
  carrierPhone: true,
  carrierName: true,
  carrierEmail: true,
  defaultCarrierPhone: true,
  manageEquipmentPhone: true,
  nonManageEquipmentPhone: true,
};

const reSendInviteResponse = {
  success: true,
  message: true
};

export class UserDetails {
  /**
   *
   * @param carrierId
   * @param roleName
   * @param size
   * @param page
   * @param sort
   */
  getUsers(carrierId: string, roleName: string , size: string, page: string , sort?: string) {
    return {
      query: {
        getMembers: {
          __args: {
            input: {
              carrierId,
              roleName,
              size,
              page,
              sort
            },
          },
          ...getMemberresponseParams,
        },
      },
    };
  }

  getUsersForWeb(carrierId: string, roleName: string , size: string, page: string , sort?: string) {
    return {
      query: {
        getMembers: {
          __args: {
            input: {
              carrierId,
              roleName,
              size,
              page,
              sort,
              requestForLoadDetails : true 
            },
          },
          ...getMemberresponseParamsForWeb,
        },
      },
    };
  }

  /**
   *
   * @param userPrincipalName
   */
  getRequestPayload(userPrincipalName: string) {
    return {
      query: {
        getUserDetails: {
          __args: {
            userPrincipalName,
          },
          ...responseParams,
          managedEquipmentCapability: true,
          nonManagedEquipmentCapability: true,
          carrierContactInfo: {
            ...CarrierContactInfo,
          },
        },
      },
    };
  }

  /**
   * Validate User Funcion return query format
   * @param mobileNumber
   */
  validateUser(mobileNumber: string) {
    return {
      query: {
        validateUserByIdentifier: {
          __args: {
            mobileNum: mobileNumber,
          },
          ...responseParams,
        },
      },
    };
  }

  /**
   * Transfer User Funcion return query format
   * @param userPrincipalName
   */
  transferMember(input: any) {
    return {
      mutation: {
        transferMemberV2: {
          __args: {
            userId: input.userId,
            roles: input.roles
          },
          status: true,
          message: true,
        },
      },
    };
  }

  /**
   * Confirm Transfer User Funcion return query format
   * @param userPrincipalName
   */
  confirmTransfer(input: any) {
    return {
      mutation: {
        confirmTransfer: {
          __args: {
            input,
          },
          status: true,
          message: true,
        },
      },
    };
  }

  /**
   * Add User Funcion return query format
   * @param userPrincipalName
   */
  addUser(input: any) {
    return {
      mutation: {
        addMemberV2: {
          __args: {
            input,
          },
          message: true,
          status: true,
          member: memberResponseParams,
        },
      },
    };
  }

  /**
   * Add User Funcion return query format
   * @param userPrincipalName
   */
  updateMember(input: any) {
    return {
      mutation: {
        updateMember: {
          __args: {
            input,
          },
          message: true,
          status: true,
          member: memberResponseParams,
        },
      },
    };
  }

  /**
   * regiter User Funcion return query format
   * @param userDetils
   */
  registerMember(input: any) {
    return {
      mutation: {
        registerMember: {
          __args: {
            input,
          },
          status: true,
          message: true,
          member: responseParams,
        },
      },
    };
  }
  /**
   * reSendInvite return query format
   */

   reSendInvite(payload: any) {
    return {
      mutation: {
        resend_invitation: {
          __args: {
            input: payload
          },
          ...reSendInviteResponse
        }
      }
    };
  }
}
